module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-page', [_c('transition', {
    attrs: {
      "name": "page-fade",
      "mode": "out-in"
    }
  }, [(_vm.track) ? _c('v-card', {
    attrs: {
      "height": "700"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "lg3": ""
    }
  }, [_c('v-card', [_c('audio-image', {
    attrs: {
      "audio": _vm.track,
      "height": "200px"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2 pt-2",
    attrs: {
      "xs12": "",
      "sm8": "",
      "lg9": ""
    }
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    staticClass: "shrink",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('h1', {
    staticClass: "display-1 name truncate"
  }, [_vm._v(_vm._s(_vm.track.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "shrink": ""
    }
  }, [_c('h2', {
    staticClass: "title grey--text"
  }, [_vm._v(_vm._s(_vm.track.artist))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_vm._l((_vm.track.tags), function(tag, index) {
    return _c('v-chip', {
      key: index,
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(tag.name))])
  }), _vm._v(" "), (_vm.$auth.user.id) ? _c('v-btn', {
    staticClass: "ma-0 no-hover-opacity",
    attrs: {
      "small": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogAddTag = !_vm.dialogAddTag
      }
    }
  }, [_c('span', [_vm._v("Edit tags")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('dialog-add-tag', {
    attrs: {
      "audio": _vm.track
    },
    model: {
      value: (_vm.dialogAddTag),
      callback: function($$v) {
        _vm.dialogAddTag = $$v
      },
      expression: "dialogAddTag"
    }
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "grey--text mt-3",
    attrs: {
      "shrink": ""
    }
  }, [_c('span', [_vm._v("Added by")]), _vm._v(" "), _c('a', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm.track.user.name))])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "xs12": ""
    }
  }, [_c('like', {
    key: _vm.track.id,
    attrs: {
      "audio": _vm.track
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-atp",
    attrs: {
      "icon": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.atpMenu = !_vm.atpMenu
      }
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1), _vm._v(" "), _c('menu-add-to-playlist', {
    attrs: {
      "audio": _vm.track,
      "activator": ".btn-atp",
      "right": ""
    },
    model: {
      value: (_vm.atpMenu),
      callback: function($$v) {
        _vm.atpMenu = $$v
      },
      expression: "atpMenu"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#lyrics",
      "disabled": ""
    }
  }, [_vm._v("Lyrics")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#comments",
      "disabled": ""
    }
  }, [_vm._v("Comments")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#resources",
      "disabled": ""
    }
  }, [_vm._v("Resources")])], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "id": "lyrics"
    }
  }, [_c('v-card', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Work in progress")])])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600475f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PageTrack.vue
// module id = 373
// module chunks = 0